"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFlatStyle = void 0;
const react_1 = require("react");
const react_native_1 = require("react-native");
const useFlatStyle = (styleFactory, deps) => react_1.useMemo(() => react_native_1.StyleSheet.flatten(styleFactory()), deps);
exports.useFlatStyle = useFlatStyle;
